import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/style.css";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import Loader from "./components/Base/Loader";

// Lazy load the App component
const LazyApp = lazy(() => import("./App"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <HelmetProvider>
      <Suspense
        fallback={<Loader fullPage={true} color={`#7086F5`} loading={true} />}
      >
        <LazyApp />
      </Suspense>
    </HelmetProvider>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
